$(document).ready(function() {
    var smartspeed_var = 600;

    // Main Slider JS

    var tvSliderSpeed = 13;
    var tvSliderAutoplay = false;
    var tvSliderLoop = false;
    var tvSliderHover = false;
    $('.tvslider-list-slider').owlCarousel({
      dots: true,
      nav: false,
      smartSpeed: smartspeed_var,
      loop: tvSliderLoop,
      autoplay: tvSliderAutoplay,
      autoplayTimeout: (tvSliderSpeed*1000),
      autoplayHoverPause: tvSliderHover,
      responsive: {
        0: {items: 1},
        320: {items: 1,slideBy: 1},
        400: {items: 1,slideBy: 1},
        575: {items: 1,slideBy: 1},
        768: {items: 1,slideBy: 1},
        992: {items: 1,slideBy: 1},
        1200: {items: 1,slideBy: 1},
        1600: {items: 1,slideBy: 1},
        1800: {items: 1,slideBy: 1}
      }
    });
    $('.tvslider-slider-prev').click(function(e) {
      e.preventDefault();
      $('.tvslider .owl-nav .owl-prev').trigger('click');
    });
    $('.tvslider-slider-next').click(function(e) {
      e.preventDefault();
      $('.tvslider .owl-nav .owl-next').trigger('click');
    });
    jQuery('.tvslider-list-slider').on('translated.owl.carousel', function(event) {
      mainSliderHomePageJs();
    });
    
    jQuery('.slideshow__text-wrapper').eq(0).addClass('active');
    function mainSliderHomePageJs() {
      var num_index = jQuery('.tvcmsmain-slider-wrapper .owl-dots').find('.owl-dot.active').index();
      jQuery('.slideshow__text-wrapper').removeClass('active');
      jQuery('.slideshow__text-wrapper').eq(num_index).addClass('active');
    }
    jQuery(document).on('click', '.slideshow__text-wrapper', function() {
      var num_index = jQuery(this).attr('data-index');
      jQuery('.slideshow__text-wrapper').removeClass('active');
      jQuery(this).addClass('active');
      jQuery('.tvcmsmain-slider-wrapper .owl-dots .owl-dot').eq(num_index).trigger('click');
    });
    setTimeout(function() {
      $(".tvslider").css("height", "auto");
    }, 1000);

    // Category Slider JS
    var tvCategorySlideBy = 1;
    var tvCategorySliderSpeed = 3;
    var tvCategorySliderAutoplay = false;
    $('.tvcategoryslider-list-slider').owlCarousel({
      loop: false,
      dots: false,
      nav: false,
      smartSpeed: smartspeed_var,
      autoplay: tvCategorySliderAutoplay,
      autoplayTimeout: (tvCategorySliderSpeed*1000),
      autoplayHoverPause: true,
      responsive: {
        0: {items: 1},
        320: {items: 2,slideBy: 1},
        400: {items: 3,slideBy: 1},
        768: {items: 4,slideBy: 1},
        992: {items: 5,slideBy: 1},
        1200: {items: 5,slideBy: 1},
        1600: {items: 6,slideBy: 1},
        1800: {items: 6,slideBy: tvCategorySlideBy}
      }
    });
    $('.tvcategoryslider-slider-prev').click(function(e) {
      e.preventDefault();
      $('.tvcategoryslider .owl-nav .owl-prev').trigger('click');
    });
    $('.tvcategoryslider-slider-next').click(function(e) {
      e.preventDefault();
      $('.tvcategoryslider .owl-nav .owl-next').trigger('click');
    });
    // $('.tvcategoryslider .tvcategoryslider-pagination-wrapper').insertAfter('.tvcategoryslider .tvcms-main-title');

    // Tab Product JS

    var mobileViewSize = 991;

    /********************** Start Tab js **********************/
$(document).on('click','.tvtabs-products .tab-index',function(e){
      var id = $(this).attr('data-tab-data');
      var paging = $(this).attr('data-tab-paging');
      $('.tab-index').removeClass('active in');
      $('.tvcmstab-product').removeClass('active in');
      $('.tvtab-pagination').removeClass('active in');
      $('.tvtab-pagination').hide();
      $(this).addClass('active in');
      $('#' + id).addClass('active in');
      $('.' + paging + '-pagination').addClass('active').show();
    });
    $('.tvtab-pagination.active').fadeIn();
    // $('.tvcmstab-title-product .tvtab-all-pagination').insertAfter('.tvcmstab-title-product .tvtab-title-wrapper');

    /********************** End Tab js *****************************/

    /****************** Start Tab Product Slider Js *******************************************/
    // const $settings_tabproduct = document.querySelector(`.tvall-tab-product-block `);
    var tvTabSlideBy = 1;
    var tvTabProductSpeed = 3;
    var tvTabProductAutoplay = false;
    // const tvTabProductSlideBy = $settings_tabproduct.getAttribute("data-slideby");
    var owlClass = [

      // ['slider className','navigation nextClass','navigation prevClass']
      [
        '.tvtab-featured-product .tvproduct-wrapper-content-box', '.tvtab-featured-product-next', '.tvtab-featured-product-prev'
      ],
      [
        '.tvtab-new-product .tvproduct-wrapper-content-box', '.tvtab-new-product-next', '.tvtab-new-product-prev'
      ],
      [
        '.tvtab-special-product .tvproduct-wrapper-content-box', '.tvtab-special-product-next', '.tvtab-special-product-prev'
      ],
      [
        '.tvtab-best-seller-product .tvproduct-wrapper-content-box', '.tvtab-best-seller-product-next', '.tvtab-best-seller-product-prev'
      ]
    ];
    for (var i = 0; i < owlClass.length; i++) {
      var owl = $(owlClass[i][0]).owlCarousel({
        loop: false,
        dots: false,
        smartSpeed: smartspeed_var,
        nav: false,
        autoplay: tvTabProductAutoplay,
        autoplayTimeout: (tvTabProductSpeed*1000),
        autoplayHoverPause: true,
        responsive: {
          0: {items: 1},
          320: {items: 1,slideBy: 1},
          330: {items: 2,slideBy: 1},
          400: {items: 2,slideBy: 1},
          480: {items: 2,slideBy: 1},
          650: {items: 3,slideBy: 1},
          767: {items: 3,slideBy: 1},
          768: {items: 3,slideBy: 1},
          992: {items: 4,slideBy: 1},
          1023: {items: 4,slideBy: 1},
          1024: {items: 4,slideBy: 1},
          1200: {items: 4,slideBy: 1},
          1350: {items: 4,slideBy: 1},
          1660: {items: 5,slideBy: 1},
          1800: {items: 5,slideBy: tvTabSlideBy}
        }
      });
      $(owlClass[i][1]).on('click', function(e) {
        e.preventDefault();
        $('#' + $(this).attr('data-parent') + ' .owl-nav .owl-next').trigger('click');
      });
      $(owlClass[i][2]).on('click', function(e) {
        e.preventDefault();
        $('#' + $(this).attr('data-parent') + ' .owl-nav .owl-prev').trigger('click');
      });

      // $('#featuredid').insertAfter('#tvcmstab-featured-product .tvtab-featured-product');
      // $('#newid').insertAfter('#tvcmstab-new-product .tvtab-new-product');
      // $('#bestid').insertAfter('#tvcmstab-best-seller-product .tvtab-best-seller-product');
      // $('#specialid').insertAfter('#tvcmstab-special-product .tvtab-special-product');
    }

    /****************** End Tab Product Slider Js *******************************************/

    /****************** Start Single Products Slider Js *******************************************/
    var swiperClass = [

      // ['slider className','navigation nextClass','navigation prevClass','paging className']
      [
        '.tvcmsfeatured-product .tvfeatured-product-wrapper', '.tvcmsfeatured-next', '.tvcmsfeatured-prev', '.tvcmsfeatured-product'
      ],
      [
        '.tvcmsnew-product .tvnew-product-wrapper', '.tvcmsnew-next', '.tvcmsnew-prev', '.tvcmsnew-product'
      ],
      [
        '.tvcmsspecial-product .tvspecial-product-wrapper', '.tvcmsspecial-next', '.tvcmsspecial-prev', '.tvcmsspecial-product'
      ],
      [
        '.tvcmsbest-seller-product .tvbest-seller-product-wrapper', '.tvcmsbest-seller-next', '.tvcmsbest-seller-prev', '.tvcmsbest-seller-product'
      ]
    ];
    for (var i = 0; i < swiperClass.length; i++) {
      $(swiperClass[i][0]).owlCarousel({
        loop: false,
        dots: false,
        nav: false,
        smartSpeed: smartspeed_var,
        responsive: {
          0: {items: 1},
          320: {items: 1,slideBy: 1},
          576: {items: 2,slideBy: 1},
          768: {items: 2,slideBy: 1},
          992: {items: 3,slideBy: 1},
          1200: {items: 4,slideBy: 1},
          1600: {items: 4,slideBy: 1},
          1800: {items: 4,slideBy: 1}
        }
      });

      $(swiperClass[i][1]).on('click', function(e) {
        e.preventDefault();
        $('.' + $(this).attr('data-parent') + ' .owl-nav .owl-next').trigger('click');
      });
      $(swiperClass[i][2]).on('click', function(e) {
        e.preventDefault();
        $('.' + $(this).attr('data-parent') + ' .owl-nav .owl-prev').trigger('click');
      });

      // $(swiperClass[i][3]+' .tv-pagination-wrapper').insertAfter(swiperClass[i][3]+' .tvtab-title-wrapper');
    }

    /****************** End Single Product Sliders Js *******************************************/
    /****************** Start featured Product Sliders Js *******************************************/
    // const $settings_featuredproduct = document.querySelector(`.featured_collection_wrapper`);
    // const tvFeaturedSliderSpeed = $settings_featuredproduct.getAttribute("data-speed");
    // const tvFeaturedSlideBy = $settings_featuredproduct.getAttribute("data-slideby");
    var tvFeaturedSlideBy = 1;
    var tvFeaturedProductSpeed = 3;
    var tvFeaturedProductAutoplay = false;
    $('.tvfeatured-collection-wrapper .tvproduct-wrapper-content-box').owlCarousel({
      loop: false,
      dots: false,
      smartSpeed: smartspeed_var,
      nav: false,
      autoplay: tvFeaturedProductAutoplay,
      autoplayTimeout: (tvFeaturedProductSpeed*1000),
      autoplayHoverPause: true,
      responsive: {
        0: {items: 1},
        320: {items: 1,slideBy: 1},
        330: {items: 2,slideBy: 1},
        400: {items: 2,slideBy: 1},
        480: {items: 2,slideBy: 1},
        650: {items: 3,slideBy: 1},
        767: {items: 3,slideBy: 1},
        768: {items: 3,slideBy: 1},
        992: {items: 4,slideBy: 1},
        1023: {items: 4,slideBy: 1},
        1024: {items: 4,slideBy: 1},
        1200: {items: 4,slideBy: 1},
        1350: {items: 4,slideBy: 1},
        1660: {items: 5,slideBy: 1},
        1800: {items: 5,slideBy: tvFeaturedSlideBy}
      }
    });
    $('.tvcmsfeatured-next').on('click', function(e) {
      e.preventDefault();
      $('.tvfeatured-collection-wrapper .owl-nav .owl-next').trigger('click');
    });
    $('.tvcmsfeatured-prev').on('click', function(e) {
      e.preventDefault();
      $('.tvfeatured-collection-wrapper .owl-nav .owl-prev').trigger('click');
    });
    // $('.tvfeatured-pagination-wrapper').insertAfter('.tvfeatured-collection-wrapper .tvcms-main-title');
  
    /****************** End featured Product Sliders Js *******************************************/

   /****************** Start Latest Sliders Js *******************************************/
  //  const $settings_latestproduct = document.querySelector(`.latest_collection_wrapper`);
  //   const tvLatestSliderSpeed = $settings_latestproduct.getAttribute("data-speed");
  //   const tvLatestSlideBy = $settings_latestproduct.getAttribute("data-slideby");
  var tvLatestSlideBy = 1;
  var tvLatestProductSpeed = 3;
  var tvLatestProductAutoplay = false;
    $('.tvlatest-collection-wrapper .tvproduct-wrapper-content-box').owlCarousel({
      loop: false,
      dots: false,
      smartSpeed: smartspeed_var,
      nav: false,
      autoplay: tvLatestProductAutoplay,
      autoplayTimeout: (tvLatestProductSpeed*1000),
      autoplayHoverPause: true,
      responsive: {
        0: {items: 1},
        320: {items: 1,slideBy: 1},
        330: {items: 2,slideBy: 1},
        400: {items: 2,slideBy: 1},
        480: {items: 2,slideBy: 1},
        650: {items: 3,slideBy: 1},
        767: {items: 3,slideBy: 1},
        768: {items: 3,slideBy: 1},
        992: {items: 4,slideBy: 1},
        1023: {items: 4,slideBy: 1},
        1024: {items: 4,slideBy: 1},
        1200: {items: 4,slideBy: 1},
        1350: {items: 4,slideBy: 1},
        1660: {items: 5,slideBy: 1},
        1800: {items: 5,slideBy: tvLatestSlideBy}
      }
    });
    $('.tvcmslatest-next').on('click', function(e) {
      e.preventDefault();
      $('.tvlatest-collection-wrapper .owl-nav .owl-next').trigger('click');
    });
    $('.tvcmslatest-prev').on('click', function(e) {
      e.preventDefault();
      $('.tvlatest-collection-wrapper .owl-nav .owl-prev').trigger('click');
    });
    // $('.tvlatest-pagination-wrapper').insertAfter('.tvlatest-collection-wrapper .tvcms-main-title');

/****************** End Latest Sliders Js *******************************************/

/****************** Start bestseller Sliders Js *******************************************/
    // const $settings_bestsellerproduct = document.querySelector(`.bestseller_collection_wrapper`);
    // const tvBestsellerSliderSpeed = $settings_bestsellerproduct.getAttribute("data-speed");
    // const tvBestsellerSlideBy = $settings_bestsellerproduct.getAttribute("data-slideby");
    var tvBestSellerSlideBy = 1; 
    var tvBestSellerProductSpeed = 3;
    var tvBestSellerProductAutoplay = false;
    $('.tvbestseller-collection-wrapper .tvproduct-wrapper-content-box').owlCarousel({
      loop: false,
      dots: false,
      smartSpeed: smartspeed_var,
      autoplay: tvBestSellerProductAutoplay,
      autoplayTimeout: (tvBestSellerProductSpeed*1000),
      nav: false,
      autoplay: true,
      // autoplayTimeout: (tvBestsellerSliderSpeed*1000),
      autoplayHoverPause: true,
      responsive: {
        0: {items: 1},
        320: {items: 1,slideBy: 1},
        330: {items: 2,slideBy: 1},
        400: {items: 2,slideBy: 1},
        480: {items: 2,slideBy: 1},
        650: {items: 3,slideBy: 1},
        767: {items: 3,slideBy: 1},
        768: {items: 3,slideBy: 1},
        992: {items: 4,slideBy: 1},
        1023: {items: 4,slideBy: 1},
        1024: {items: 4,slideBy: 1},
        1200: {items: 4,slideBy: 1},
        1350: {items: 4,slideBy: 1},
        1660: {items: 5,slideBy: 1},
        1800: {items: 5,slideBy: tvBestSellerSlideBy}
      }
    });
    $('.tvcmsbestseller-next').on('click', function(e) {
      e.preventDefault();
      $('.tvbestseller-collection-wrapper .owl-nav .owl-next').trigger('click');
    });
    $('.tvcmsbestseller-prev').on('click', function(e) {
      e.preventDefault();
      $('.tvbestseller-collection-wrapper .owl-nav .owl-prev').trigger('click');
    });
    // $('.tvbestseller-pagination-wrapper').insertAfter('.tvbestseller-collection-wrapper .tvcms-main-title');

/****************** End bestseller Sliders Js *******************************************/  
// const $settings_brandlist = document.querySelector(`.tvbrandlist-list-slider`);
// const tvBrandSliderSpeed = $settings_brandlist.getAttribute("data-speed");
// const tvBrandSlideBy = $settings_brandlist.getAttribute("data-slideby");
    var tvBrandSlideBy = 1; 
    var tvBrandSpeed = 3;
    var tvBrandAutoplay = false;
    function ScrollExecute() {
      var scrollNode = $('#AjaxinatePagination').last();
      var scrollURL = $('#AjaxinatePagination a.paging-link').last().attr("href");
      $.ajax({
        type: 'GET',
        url: scrollURL,
        beforeSend: function() {
          $('#AjaxinatePaginationLoading').show();
        },
        success: function(data) {
          $("#AjaxinatePagination").show();
          $('#AjaxinatePaginationLoading').hide();
          var filteredData = $(data).find(".AjaxinateLoop");
          var filteredPagingData = $(data).find("#AjaxinatePagination");
          $(".AjaxinateLoop").append(filteredData);
          $("#AjaxinatePagination").html(filteredPagingData[0].innerHTML);
        },
        dataType: "html"
      });
    }
    $(document).on('click', '.paging-link', function(e) {
      e.preventDefault();
      $("#AjaxinatePagination").hide();
      ScrollExecute();
    });

    // Brandlist Slider JS


    $('.tvbrandlist-list-slider').owlCarousel({
      loop: false,
      dots: false,
      nav: false,
      smartSpeed: smartspeed_var,
      autoplay: tvBrandAutoplay,
      autoplayTimeout: (tvBrandSpeed*1000),
      autoplayHoverPause: true,
      responsive: {
        0: {items: 1},
        330: {items: 1,slideBy: 1},
        330: {items: 2,slideBy: 1},
        400: {items: 2,slideBy: 1},
        575: {items: 3,slideBy: 1},
        768: {items: 3,slideBy: 1},
        992: {items: 4,slideBy: 1},
        1200: {items: 5,slideBy: 1},
        1600: {items: 6,slideBy: 1},
        1800: {items: 6,slideBy: tvBrandSlideBy}
      }
    });
    $('.tvbrandlist-slider-prev').click(function(e) {
      e.preventDefault();
      $('.tvbrandlist .owl-nav .owl-prev').trigger('click');
    });
    $('.tvbrandlist-slider-next').click(function(e) {
      e.preventDefault();
      $('.tvbrandlist .owl-nav .owl-next').trigger('click');
    });

    // Sidebar Blog Slider JS
    // const $settings_sideblog = document.querySelector(`.sidebat-featured-post`);
    // const tvBlogSliderSpeed = $settings_sideblog.getAttribute("data-speed");
    // const tvBlogSlideBy = $settings_sideblog.getAttribute("data-slideby");
    var tvSideBlogSpeed = 3;
    var tvSideBlogAutoplay = false;
    var tvSideBlogSlideBy = 1; 
    $('.sidebat-featured-post').owlCarousel({
      loop: false,
      dots: false,
      nav: false,
      autoplay: tvSideBlogAutoplay,
      smartSpeed: smartspeed_var,
      autoplayTimeout: (tvSideBlogSpeed*1000),
      autoplayHoverPause: true,
      responsive: {
        0: {items: 1},
        320: {items: 1,slideBy: 1},
        400: {items: 1,slideBy: 1},
        768: {items: 2,slideBy: 1},
        992: {items: 2,slideBy: 1},
        1000: {items: 3,slideBy: 1},
        1199: {items: 3,slideBy: 1},
        1200: {items: 1,slideBy: 1},
        1600: {items: 1,slideBy: 1},
        1800: {items: 1,slideBy: tvSideBlogSlideBy}
      }
    });
    $('.tvblog-prev').click(function(e) {
      e.preventDefault();
      $('.sidebat-featured-post .owl-nav .owl-prev').trigger('click');
    });
    $('.tvblog-next').click(function(e) {
      e.preventDefault();
      $('.sidebat-featured-post .owl-nav .owl-next').trigger('click');
    });

    // Testimonial Slider JS
    // const $settings_testimonial = document.querySelector(`.tvtestimonial-slider`);
    // const tvTestimonialSliderSpeed = $settings_testimonial.getAttribute("data-speed");
    // const tvTestimonialSlideBy = $settings_testimonial.getAttribute("data-slideby");
    var tvTestimonialSpeed = 3;
    var tvTestimonialAutoplay = false;
    var tvTestimonialSlideBy = 1; 
    $('.tvtestimonial-sidebar-slider').owlCarousel({
      loop: false,
      dots: false,
      nav: false,
      smartSpeed: smartspeed_var,
      autoplay: tvTestimonialAutoplay,
      autoplayTimeout: (tvTestimonialSpeed*1000),
      autoplayHoverPause: true,
      responsive: {
        0: {items: 1},
        320: {items: 1,slideBy: 1},
        400: {items: 1,slideBy: 1},
        575: {items: 1,slideBy: 1},
        768: {items: 1,slideBy: 1},
        992: {items: 1,slideBy: 1},
        1200: {items: 1,slideBy: 1},
        1600: {items: 1,slideBy: 1},
        1800: {items: 1,slideBy: tvTestimonialSlideBy}
      }
    });
    $('.tvtestimonial-prev').click(function(e) {
      e.preventDefault();
      $('#testimonial-slide .owl-nav .owl-prev').trigger('click');
    });
    $('.tvtestimonial-next').click(function(e) {
      e.preventDefault();
      $('#testimonial-slide .owl-nav .owl-next').trigger('click');
    });

    $('.tvtestimonial-slider').owlCarousel({
      loop: false,
      dots: true,
      nav: false,
      autoplay: true,
      smartSpeed: smartspeed_var,
      autoplayTimeout: (tvTestimonialSpeed*1000),
      autoplayHoverPause: true,
      responsive: {
        0: { items: 1 },
        320: { items: 1, slideBy: 1 },
        400: { items: 1, slideBy: 1 },
        575: { items: 1, slideBy: 1 },
        768: { items: 1, slideBy: 1 },
        992: { items: 1, slideBy: 1 },
        1200: { items: 1, slideBy: 1 },
        1600: { items: 1, slideBy: 1 },
        1800: { items: 1, slideBy: tvTestimonialSlideBy}
      },
    });
    $('.tvtestimonial-slider-prev').click(function(e) {
      e.preventDefault();
      $('.tvtestimonial .owl-nav .owl-prev').trigger('click');
    });

    $('.tvtestimonial-slider-next').click(function(e) {
      e.preventDefault();
      $('.tvtestimonial .owl-nav .owl-next').trigger('click');
    });

    // Collectioncategoryslider List Slider JS

    var tvCollectionCategorySpeed = 3;
    var tvCollectionCategoryAutoplay = false;
    var tvCollectionSlideBy = 1; 
    $('.tvcollectioncategoryslider-list-slider').owlCarousel({
      loop: false,
      dots: false,
      nav: false,
      autoplay: tvCollectionCategoryAutoplay,
      smartSpeed: smartspeed_var,
      autoplayTimeout: (tvCollectionCategorySpeed*1000),
      autoplayHoverPause: true,
      responsive: {
        0: {items: 1},
        320: {items: 1,slideBy: 1},
        330: {items: 2,slideBy: 1},
        425: {items: 2,slideBy: 1},
        575: {items: 3,slideBy: 1},
        768: {items: 3,slideBy: 1},
        860: {items: 3,slideBy: 1},
        992: {items: 4,slideBy: 1},
        1200: {items: 4,slideBy: 1},
        1600: {items: 5,slideBy: 1},
        1800: {items: 5,slideBy: tvCollectionSlideBy}
      }
    });
    $('.tvcollectioncategoryslider-slider-prev').click(function(e) {
      e.preventDefault();
      $('.tvcollectioncategoryslider .owl-nav .owl-prev').trigger('click');
    });
    $('.tvcollectioncategoryslider-slider-next').click(function(e) {
      e.preventDefault();
      $('.tvcollectioncategoryslider .owl-nav .owl-next').trigger('click');
    });
    // $('.tvcollectioncategoryslider .tvcollectioncategoryslider-pagination-wrapper').insertAfter('.tvcollectioncategoryslider .tvcollectioncategoryslider-main-title-wrapper .tvmain-title');
  });


// Image Gallery Slider JS

    // const $settings_collection = document.querySelector(`.tvimage-gallery-list-slider`);
    // const tvImageGallerySliderSpeed = $settings_collection.getAttribute("data-speed");
    // const tvImageGallerySlideBy = $settings_collection.getAttribute("data-slideby");
    var tvImageGallerySpeed = 3;
    var tvImageGalleryAutoplay = false;
    var tvImageGallerySlideBy = 1; 

  $(document).ready(function() {
    $('.tvimage-gallery-list-slider').owlCarousel({
      loop: false,
      dots: false,
      nav: false,
      autoplay: tvImageGalleryAutoplay,
      autoplayTimeout: (tvImageGallerySpeed*1000),
      autoplayHoverPause: true,
      responsive: {
        0: { items: 1 },
        320: { items: 1, slideBy: 2 },
        400: { items: 1, slideBy: 1 },
        525: { items: 2, slideBy: 1 },
        768: { items: 2, slideBy: 1 },
        992: { items: 3, slideBy: 1 },
        1200: { items: 3, slideBy: 1 },
        1600: { items: 4, slideBy: 1 },
        1800: { items: 4, slideBy: tvImageGallerySlideBy }
      },
    });
    $('.tvimage-gallery-slider-prev').click(function(e) {
      e.preventDefault();
      $('.tvimage-gallery .owl-nav .owl-prev').trigger('click');
    });

    $('.tvimage-gallery-slider-next').click(function(e) {
      e.preventDefault();
      $('.tvimage-gallery .owl-nav .owl-next').trigger('click');
    });
  });